import { render, staticRenderFns } from "./NewUsersSlider.vue?vue&type=template&id=0588028a&scoped=true&"
import script from "./NewUsersSlider.vue?vue&type=script&lang=js&"
export * from "./NewUsersSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewUsersSlider.vue?vue&type=style&index=0&id=0588028a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588028a",
  null
  
)

export default component.exports